import React from "react";
import LegalDocument from "../components/site/LegalDocument";
import LEGAL_DOCUMENTS from "../content/legal";

const Terms = () => (
  <LegalDocument blocks={LEGAL_DOCUMENTS.terms} pageTitle="Terms of Use · Mise" testId="page-terms" />
);

export default Terms;
